import { IntegrationListItem } from '../common/components/integration-list-item/integration-list-item'
import { integrationsMetadata } from '../common/metadata'
import { Integration } from '../common/interfaces'
import React from 'react'

interface MicrosoftTeamsIntegrationProps {
  readonly integrations: Integration[]
}

export const MicrosoftTeamsIntegration = ({
  integrations
}: MicrosoftTeamsIntegrationProps) => {
  return (
    <>
      <IntegrationListItem
        isConnected={integrations.length > 0}
        {...integrationsMetadata.microsoftTeams}
      />
    </>
  )
}
